import { render, staticRenderFns } from "./LevelFormulaeContainer.vue?vue&type=template&id=3bd534a6&"
import script from "./LevelFormulaeContainer.vue?vue&type=script&lang=js&"
export * from "./LevelFormulaeContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports